import { useEffect, useState, useCallback } from "react";
import { ReactComponent as Upload } from "../../assets/images/svg/Upload.svg";
import { useLocation } from "react-router-dom";
// import FileSaver from "file-saver";
import Swal from "sweetalert2";
import * as XLSX from "xlsx"
import FileSaver, { saveAs } from "file-saver";

import { EXCEL_FILE_BASE64 } from "../../constants";
import LabelOptions from "./LabelOptions";
import useSocket from "../../hooks/useWebsocket";
import axios from "../../utils/axios";
import useAuth from "../../hooks/useAuth";
import { TopDisappearingMessage } from "../../utils/Common";

const UploadCustomer = ({
  file = { name: "" },
  invalidFile = { name: "" },
  callLatestFirst = false,
  showRunningNote = false,
  setData,
  setActive,
  SetExcelCount,
  next,
  back
}) => {
  const location = useLocation();
  const pathArray = location.pathname.split("/");
  const campaignId = pathArray.pop();

  const { auth, setAuth } = useAuth();
  

  const BASE_URL = process.env.REACT_APP_API_URL;

  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [isInvalidFile,setInvalidFile] = useState(false)

  // Check if file is uploaded
  useEffect(() => {
    const hasFile = file && file.name && file.name !== "";
    setIsFileUploaded(hasFile);
    console.log(file)
  }, [file]);

  useEffect(()=>{
    // console.log(`invalidFile.name ${invalidFile.name}`)
    const hasInvalidFIle = invalidFile && invalidFile.name && invalidFile.name !== "";
    setInvalidFile(hasInvalidFIle)
  },[invalidFile]);

  

  // Handle file upload
  const handleFileUpload = useCallback((event) => {
    const selectedFile = event.target.files[0];

      const reaquiredHeaders = [
        "SlNumber",
        "Name",
        "CustomerNumber",
        "Agent",
        "Description"
      ];

    if (!selectedFile) {
      return;
    }

    // Validate file type
    const allowedTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv'
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      Swal.fire({
        title: "Invalid File Type",
        text: "Please upload an Excel (.xlsx, .xls) or CSV file.",
        icon: "error"
      });
      return;
    }

    // Validate file size (max 10MB)
    const maxSizeInBytes = 10 * 1024 * 1024;
    if (selectedFile.size > maxSizeInBytes) {
      Swal.fire({
        title: "File Too Large",
        text: "Please upload a file smaller than 10MB.",
        icon: "error"
      });
      return;
    }




    const reader = new FileReader();

    

    reader.onload = (event2) => {
      // alert("read start")
      const data = new Uint8Array(event2.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const jsonRows = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      const headers = jsonData[0]; // first row → header row

      SetExcelCount(parseInt(jsonRows.length))

      if(!headers){
        Swal.fire({
          title: "Missing Fields",
          text: `Missing required title fields: SlNumber, Name, CustomerNumber, Agent, Description. You can download the sample Excel file above to see the correct format.`,
          icon: "error",
          showConfirmButton: true
        });
        setIsFileUploaded(false);
        event.target.value = ""
        return;
      }

      const missingHeaders = reaquiredHeaders.filter(
        (h) => !headers.includes(h)
      );

      if ( !headers || missingHeaders.length > 0) {

        
        Swal.fire({
          title: "Missing Fields",
          text: `Missing required title fields: ${missingHeaders.join(", ")}. You can download the sample Excel file above to see the correct format.`,
          icon: "error",
          showConfirmButton: true
        });
        setIsFileUploaded(false);
        event.target.value = ""
        return;
      }

      // Check for duplicate column titles
      const normalizedHeaders = headers
        .map(h => String(h).trim())
        .filter(h => h !== "");

      const duplicateHeaders = normalizedHeaders.filter(
        (header, index) => normalizedHeaders.indexOf(header) !== index
      );

      if (duplicateHeaders.length > 0) {
        const uniqueDuplicates = [...new Set(duplicateHeaders)];

        Swal.fire({
          title: "Duplicate Column Titles",
          text: `Duplicate column titles found: ("${uniqueDuplicates.join(`", `)}"). Please ensure each column title appears only once.`,
          icon: "error",
          showConfirmButton: true,
        });

        setIsFileUploaded(false);
        event.target.value = "";
        return;
      }


      // value empty
      let hasData = false;

      for (let i = 0; i < jsonRows.length; i++) {
        const row = jsonRows[i];

        // Check if ANY required column has a value
        const rowHasValue = reaquiredHeaders.some(
          (field) => row[field] && String(row[field]).trim() !== ""
        );
        // alert(`${rowHasValue}, ${JSON.stringify(row)}`)
        if (rowHasValue) {
          hasData = true;
          break;
        }
      }

      // If no rows have any values → ERROR
      if (!hasData) {

        Swal.fire(
          "Missing Fields",
          "Column titles exist, but no values are entered below them.",
          "error"
        );

        setIsFileUploaded(false);
        event.target.value = ""
        return;
      }

      setData(prevState => ({
          ...prevState,
          file: selectedFile
        }));
    
        Swal.fire({
          title: "File Uploaded Successfully!",
          text: `File "${selectedFile.name}" has been uploaded.`,
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });



   };
    

   reader.onerror = (event2)=>{
    alert("reader error")
   }

   reader.readAsArrayBuffer(selectedFile);


  }, [setData]);

  const handleCallLatestFirst = (event) => {
    setData((prevState) => ({
      ...prevState,
      callLatestFirst: event.target.value === "recent"
    }));
  };

  // Handle next step navigation
  const handleNext = useCallback(() => {
    if (!file || !file.name) {
      Swal.fire({
        title: "No File Selected",
        text: "Please upload a customer file to continue.",
        icon: "warning"
      });
      return;
    }
    setActive(next);
  }, [file, setActive, next]);

  // Handle back navigation
  const handleBack = useCallback(() => {
    setActive(back);
  }, [setActive, back]);

  // Download sample Excel sheet
  // const handleDownload = useCallback(() => {
  //   try {
  //     const dataBlob = EXCEL_FILE_BASE64;
  //     const sliceSize = 1024;
  //     const byteCharacters = atob(dataBlob);
  //     const bytesLength = byteCharacters.length;
  //     const sliceCount = Math.ceil(bytesLength / sliceSize);
  //     const byteArrays = new Array(sliceCount);

  //     for (let sliceIndex = 0; sliceIndex < sliceCount; ++sliceIndex) {
  //       const begin = sliceIndex * sliceSize;
  //       const end = Math.min(begin + sliceSize, bytesLength);
  //       const bytes = new Array(end - begin);

  //       for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
  //         bytes[i] = byteCharacters[offset].charCodeAt(0);
  //       }

  //       byteArrays[sliceIndex] = new Uint8Array(bytes);
  //     }

  //     const blob = new Blob(byteArrays, { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  //     FileSaver.saveAs(blob, "CampaignExcelSheet.xlsx");

  //     Swal.fire({
  //       title: "Download Started",
  //       text: "Sample Excel sheet is being downloaded.",
  //       icon: "success",
  //       timer: 2000,
  //       showConfirmButton: false
  //     });
  //   } catch (error) {
  //     console.error("Error downloading file:", error);
  //     Swal.fire({
  //       title: "Download Error",
  //       text: "Failed to download sample sheet. Please try again.",
  //       icon: "error"
  //     });
  //   }
  // }, []);

  // Get display filename
  const handleDownload = useCallback(() => {
    try {
      const headers = [
        ["SlNumber", "Name", "CustomerNumber", "Agent", "Description"],
      ];

      // Create a worksheet with only headers
      const worksheet = XLSX.utils.aoa_to_sheet(headers);

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

      // Write the file and trigger download
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

      saveAs(blob, "CampaignExcelSheet.xlsx");

      Swal.fire({
        title: "Download Started",
        text: "Sample Excel sheet is being downloaded.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });
    } catch (error) {
      console.error("Error downloading file:", error);
      Swal.fire({
        title: "Download Error",
        text: "Failed to download sample sheet. Please try again.",
        icon: "error"
      });
    }
  }, []);
  
  const getDisplayFileName = useCallback(() => {
    if (!file || !file.name) return "";

    if (campaignId === "0") {
      return file.name;
    } else {
      const parts = file.name.split("/");
      return parts[parts.length - 1];
    }
  }, [file, campaignId]);

  const  downloadInvalidExcel= async(e)=>{
      
      if(! invalidFile.name){
        console.log("download failed")
        return;
      } 
      else{
  
        const response = await axios.get(BASE_URL + invalidFile.name, {
          responseType: "blob"
        });
  
        // Create a blob link for download
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
  
        const link = document.createElement("a");
        link.href = url;
        link.download = invalidFile.name.split("/").pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
  
        Swal.fire({
          title: "Download Started",
          text: "Sample Excel sheet is being downloaded.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });
  
        console.log("download success")
      }
    }

  return (
    <div className="max-w-5xl p-6 ml-5">
      {/* Header Section */}
      <div className="mb-8">
        <p className="text-sm text-slate-400 mb-2">Step 6/7</p>
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-gray-800">Upload Your Customers</h1>
          <button
            onClick={handleDownload}
            className="px-4 py-2 font-semibold text-white bg-green-600 hover:bg-green-700 rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-300"
          >
            Download Sample
          </button>
        </div>
        <p className="text-sm text-slate-400 pb-6 border-b-2 border-gray-200">
          Please upload a customer file to create your campaign
        </p>
      </div>

      {/* File Upload Section */}
      <div className="mb-8">
        <label htmlFor="file-upload" className="block text-lg font-medium text-slate-600 mb-4">
          Upload Customer File
        </label>

        <div className="w-full">
          <label
            htmlFor="file-upload"
            className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-xl cursor-pointer transition-all duration-200 ${isFileUploaded
                ? "border-green-400 bg-green-50 hover:bg-green-100"
                : "border-gray-300 bg-gray-50 hover:bg-gray-100"
              }`}
          >
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <Upload
                className={`w-12 h-12 mb-3 transition-colors duration-200 ${isFileUploaded ? "text-green-500" : "text-gray-400"
                  }`}
                fill="currentColor"
              />
              <p className={`text-sm font-medium ${isFileUploaded ? "text-green-600" : "text-gray-600"
                }`}>
                {isFileUploaded ? "File uploaded successfully!" : "Click to upload customer file"}
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Supports Excel (.xlsx, .xls) and CSV files (Max: 10MB)
              </p>
            </div>
            <input
              id="file-upload"
              type="file"
              className="hidden"
              accept=".xlsx,.xls,.csv"
              onChange={handleFileUpload}
            />
          </label>
        </div>

        {/* File Info Display */}
        {isFileUploaded && (
          <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-green-800">Uploaded File:</p>
                <p className="text-sm text-green-600 font-mono break-all">
                  {getDisplayFileName()}
                </p>
                {file.size && (
                  <p className="text-xs text-green-500 mt-1">
                    Size: {(file.size / (1024 * 1024)).toFixed(2)} MB
                  </p>
                )}
              </div>
              <div className="ml-4">
                <svg className="w-8 h-8 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="mb-8">
        <div className="w-[15rem]">
          <h1
            className="text-md text-slate-400"
            title="When Recent lead is selected, customers are called starting from the most recently uploaded, in reverse order. When Older lead is selected, customers are called in upload order (oldest first)."
          >
            Dial priority
          </h1>
          <select
            id="call_latest_first"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 mt-2"
            value={callLatestFirst ? "recent" : "older"}
            onChange={handleCallLatestFirst}
          >
            <option value="older">Older lead</option>
            <option value="recent">Recent lead</option>
          </select>
        </div>
        <p className="text-xs text-slate-400 mt-1">
          Recent lead: customers are called starting from the most recently uploaded, in reverse order. Older lead: customers are called in upload order (oldest first).
        </p>
        {showRunningNote && (
          <p className="text-xs text-amber-600 mt-1">
            This campaign is running. Changes to this setting apply from the next customer picked; customers already assigned are not affected.
          </p>
        )}
      </div>

      {isInvalidFile && (
        <div className="text-center">
          <button
            onClick={downloadInvalidExcel}
            className="px-3 py-2 flex items-center justify-center gap-2 text-sm border border-red-500 text-red-500 rounded hover:bg-red-500/10 w-full transition duration-300 ease-in-out"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 
                  0 0021 18.75V16.5M7.5 12l4.5 4.5m0 0L16.5 12m-4.5 
                  4.5V3"
              />
            </svg>
            Download Invalid Data
          </button>
        </div>
      )}



      {/* <button class="px-3 py-1 text-sm border border-yellow-500 text-yellow-500 rounded hover:bg-yellow-500 hover:text-white transition">
        View Invalid Data
      </button> */}


      {/* Navigation Buttons */}
      <div className="flex justify-between items-center pt-6">
        <button
          onClick={handleBack}
          className="px-8 py-3 font-semibold text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
        >
          Back
        </button>

        <button
          onClick={handleNext}
          disabled={!isFileUploaded}
          className="font-bold text-lg rounded-full w-36 h-12"
          style={{
            backgroundImage:
              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
            color: "white",
          }}>
          Next Step
        </button>
      </div>
    </div>
  );
};

export default UploadCustomer;